import {
  SEARCHING,
  SEARCH_FINISHED,
  SEARCH_ERROR,
  GETTING_MORE_DATA,
  GOT_MORE_DATA,
  MORE_DATA_ERROR
} from "./actionTypes";
import changeKey from "./keyAction";
import { preSuggestedVideos } from "./suggestedVideosAction";
import { gettingDetails } from "./detailsAction";
import yangAxios from "../YangAxios";

export const search = str => {
  return async (dispatch, getStore) => {
    dispatch(searching(true));
    const keys = getStore().apiKey.keys;
    let index = getStore().apiKey.currentKey;
    try {
      let res = await yangAxios.get(
        `/search?part=snippet&q=${str}&maxResults=15&eventType=completed&type=video&safeSearch=strict&key=${
          keys[index]
        }`
      );
      res = res.data;
      res.items.forEach((item, i) => {
        dispatch(gettingDetails(item.id.videoId, i, "search"));
      });
      dispatch(searchFinished(res));
      dispatch(preSuggestedVideos(res));
    } catch (err) {
      if (index < keys.length && err.response && err.response.status === 403) {
        index++;
        dispatch(changeKey(index));
        dispatch(search(str));
        return;
      }
      let error = {};
      if (!err.response) {
        error = {
          error: "Network error",
          code: 400,
          message: "There's something wrong with your network."
        };
      } else {
        let customErr = err.response.data;
        error = {
          error: customErr.error.errors[0].reason,
          message: customErr.error.message,
          code: customErr.error.code
        };
      }
      dispatch(searchError(error));
    }
    dispatch(searching(false));
  };
};

export const searching = val => {
  return {
    type: SEARCHING,
    payload: val
  };
};

export const searchFinished = data => {
  return {
    type: SEARCH_FINISHED,
    payload: data
  };
};

export const searchError = err => {
  return {
    type: SEARCH_ERROR,
    payload: err
  };
};

export const getMoreData = (id, q) => {
  return async (dispatch, getStore) => {
    dispatch(gettingMoreData(true));
    const keys = getStore().apiKey.keys;
    let index = getStore().apiKey.currentKey;
    try {
      let res = await yangAxios(
        `/search?part=snippet&maxResults=15&type=video&eventType=completed&q=${q}&safeSearch=strict&pageToken=${id}&key=${
          keys[index]
        }`
      );
      res = res.data;
      res.items.forEach((item, i) => {
        dispatch(gettingDetails(item.id.videoId, i, "search"));
      });
      dispatch(gotMoreData(res));
    } catch (err) {
      if (index < keys.length && err.response && err.response.status === 403) {
        index++;
        dispatch(changeKey(index));
        dispatch(getMoreData(id, q));
        return;
      }
      let customErr = err.response.data.error;
      const error = {};
      error.code = customErr.code;
      error.error = customErr.errors[0].reason;
      error.message = customErr.errors[0].message;
      dispatch(moreDateError(error));
    }
    dispatch(gettingMoreData(false));
  };
};
export const gettingMoreData = val => {
  return {
    type: GETTING_MORE_DATA,
    payload: val
  };
};

export const gotMoreData = data => {
  return {
    type: GOT_MORE_DATA,
    payload: data
  };
};

export const moreDateError = error => {
  return {
    type: MORE_DATA_ERROR,
    payload: error
  };
};
